import styled from 'styled-components';
import { Form } from '@unform/web';

export const Container = styled(Form)``;
